<template>
    <v-dialog v-model="dialog" persistent fullscreen
    >
        <!-- Use config background image instead of video when configured -->
        <div v-if="useCustomBackground" class="login-custom-bg" :style="customBgStyle">
            <div v-if="hasOverlay" class="login-bg-overlay" :style="overlayStyle"></div>
            <v-layout align-center justify-center column fill-height style="position:relative; z-index:1;">
                <v-spacer></v-spacer>
                <v-card :style="cardStyle">
                    <v-card-title :class="cardTitleClass" :style="cardTitleStyle">
                        <img v-if="configLogo" :src="configLogo" height="40"/>
                        <img v-else-if="brandName=='JEC'" :src="require('@/assets/img/logojec.jpg')" height="50"/>
                        <img v-else-if="brandName=='Carnot Innovations'" :src="require('@/assets/img/newlogo.png')" height="40"/>
                        <span v-if="configTitle">{{configTitle}}</span>
                        <span v-else-if="brandName!=='JEC'">{{brandName}}</span>
                    </v-card-title>
                    <p v-if="configSubtitle" class="text-xs-center grey--text px-3 mb-0 mt-2">{{configSubtitle}}</p>
                    <v-card-text v-if="authMode==='main'">
                        <v-text-field
                            v-model="username"
                            :label="'User'|translate"
                            id="username"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="password"
                            type="password"
                            :label="'Password'|translate"
                            id="password"
                            @keyup.enter="loginProcess"
                        ></v-text-field>
                        <v-text-field
                            v-if="twoFactorAuth"
                            v-model="twoFactorInput"
                            type="password"
                            :label="'Two factor auth code'|translate"
                            id="2fa"
                            @keyup.enter="loginProcess"
                        ></v-text-field>
                        <div v-if="twoFactorAuth&&qrCode">
                            <h3>Two factor authentication setup</h3>
                            <p>Scan the following barcode with your phone's OTP app (e.g. Google Authenticator):</p>
                            <qr-code :text="qrCode" :size="512"></qr-code>
                        </div>
                        <v-card-actions class="pa-0">
                            <span v-if="message&&message!=''" class="mr-2">{{message}}</span> <v-btn block class="primary elevation-4" :style="loginBtnStyle" @click="loginProcess" id="login">{{'Login'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions v-if="showAdvancedLoginOptions&&!mobileMode" class="pa-0 pt-2">
                            <v-switch color="success" v-model="longExpToken" class="pa-0 ma-0 pt-3"
                                      :label="'Long expiration'|translate"></v-switch>
                            <v-spacer></v-spacer>
                            <v-btn small flat @click="urlDialog=true" class="grey--text">{{'Set Server URL'|translate}}</v-btn>
                            <set-u-r-l v-model="urlDialog"></set-u-r-l>
                        </v-card-actions>
                    </v-card-text>
                    <v-card-text v-if="authMode==='msal'">
                        <p v-if="!loading&&authOverride">
                            {{'Microsoft authentication anomaly. Please renew login.'|translate}}
                        </p>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&authOverride">
                            <v-btn color="#505050" large @click="$msal.signOut()">{{'Log Out'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&!authOverride">
                            <v-btn v-if="!$msal.isAuthenticated()" color="#505050" large @click="$msal.signIn()">{{'Login'|translate}}</v-btn>
                            <v-btn v-else color="#505050" large @click="redirectHome">{{'Back to Home'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="loading">
                            <v-progress-circular :indeterminate="loading" size="50"></v-progress-circular>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
                <v-spacer></v-spacer>
                <div v-if="showPoweredBy" style="margin-top: 200px;">
                    <img class="ml-1 grey--text" :src="require('@/assets/img/newlogo.png')" height="27"/>
                    <span class="ml-2 mr-5 grey--text" style="padding-top: 0">powered by <strong>Carnot Innovations</strong></span>
                </div>
                <div v-if="footerText" class="login-footer-text grey--text" style="margin-top:8px;">
                    <span>{{footerText}}</span>
                    <span v-for="link in footerLinks" :key="link.url" class="ml-2">
                        <a :href="link.url" class="grey--text text--lighten-1" style="text-decoration:none;">{{link.label}}</a>
                    </span>
                </div>
            </v-layout>
        </div>

        <!-- Default: video background (original behavior) -->
        <video-bg v-else :sources="[require('@/assets/video/login.mp4')]" :img="require('@/assets/video/login.png')" fill-height>
            <v-layout align-center justify-center column fill-height>
                <v-spacer></v-spacer>
                <v-card :style="cardStyle">
                    <v-card-title :class="cardTitleClass" :style="cardTitleStyle">
                        <img v-if="configLogo" :src="configLogo" height="40"/>
                        <img v-else-if="brandName=='JEC'" :src="require('@/assets/img/logojec.jpg')" height="50"/>
                        <img v-else-if="brandName=='Carnot Innovations'" :src="require('@/assets/img/newlogo.png')" height="40"/>
                        <span v-if="configTitle">{{configTitle}}</span>
                        <span v-else-if="brandName!=='JEC'">{{brandName}}</span>
                    </v-card-title>
                    <p v-if="configSubtitle" class="text-xs-center grey--text px-3 mb-0 mt-2">{{configSubtitle}}</p>
                    <v-card-text v-if="authMode==='main'">
                        <v-text-field
                            v-model="username"
                            :label="'User'|translate"
                            id="username"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="password"
                            type="password"
                            :label="'Password'|translate"
                            id="password"
                            @keyup.enter="loginProcess"
                        ></v-text-field>
                        <v-text-field
                            v-if="twoFactorAuth"
                            v-model="twoFactorInput"
                            type="password"
                            :label="'Two factor auth code'|translate"
                            id="2fa"
                            @keyup.enter="loginProcess"
                        ></v-text-field>
                        <div v-if="twoFactorAuth&&qrCode">
                            <h3>Two factor authentication setup</h3>
                            <p>Scan the following barcode with your phone's OTP app (e.g. Google Authenticator):</p>
                            <qr-code :text="qrCode" :size="512"></qr-code>
                        </div>
                        <v-card-actions class="pa-0">
                            <span v-if="message&&message!=''" class="mr-2">{{message}}</span> <v-btn block class="primary elevation-4" :style="loginBtnStyle" @click="loginProcess" id="login">{{'Login'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions v-if="showAdvancedLoginOptions&&!mobileMode" class="pa-0 pt-2">
                            <v-switch color="success" v-model="longExpToken" class="pa-0 ma-0 pt-3"
                                      :label="'Long expiration'|translate"></v-switch>
                            <v-spacer></v-spacer>
                            <v-btn small flat @click="urlDialog=true" class="grey--text">{{'Set Server URL'|translate}}</v-btn>
                            <set-u-r-l v-model="urlDialog"></set-u-r-l>
                        </v-card-actions>
                    </v-card-text>
                    <v-card-text v-if="authMode==='msal'">
                        <p v-if="!loading&&authOverride">
                            {{'Microsoft authentication anomaly. Please renew login.'|translate}}
                        </p>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&authOverride">
                            <v-btn color="#505050" large @click="$msal.signOut()">{{'Log Out'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&!authOverride">
                            <v-btn v-if="!$msal.isAuthenticated()" color="#505050" large @click="$msal.signIn()">{{'Login'|translate}}</v-btn>
                            <v-btn v-else color="#505050" large @click="redirectHome">{{'Back to Home'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="loading">
                            <v-progress-circular :indeterminate="loading" size="50"></v-progress-circular>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
                <v-spacer></v-spacer>
                <div v-if="showPoweredBy" style="margin-top: 200px;">
                    <img class="ml-1 grey--text" :src="require('@/assets/img/newlogo.png')" height="27"/>
                    <span class="ml-2 mr-5 grey--text" style="padding-top: 0">powered by <strong>Carnot Innovations</strong></span>
                </div>
                <div v-if="footerText" class="login-footer-text grey--text" style="margin-top:8px;">
                    <span>{{footerText}}</span>
                    <span v-for="link in footerLinks" :key="link.url" class="ml-2">
                        <a :href="link.url" class="grey--text text--lighten-1" style="text-decoration:none;">{{link.label}}</a>
                    </span>
                </div>
            </v-layout>
        </video-bg>

    </v-dialog>
</template>

<script>
    import VideoBg from 'vue-videobg'
    import {login, jwtDecode} from '../../helper'
    import { msalMixin } from "vue-msal";
    import SetURL from './setURL'

  export default {
      name: 'LoginDialog',
      components: {SetURL,VideoBg},
      mixins: [msalMixin],
      props: {
          loginConfig: {
              type: Object,
              default: () => ({})
          }
      },
      data() {
          return {
              dialog: false,
              loading:false,
              twoFactorAuth:false,
              twoFactorInput:null,
              showAdvancedLoginOptions:false,
              longExpToken:false,
              qrCode:null,
              password: '',
              username: '',
              message: '',
              urlDialog: false,
              authOverride:false,
          }
      },
    watch: {
        loginConfigLoaded(val) {
            if (val && !this.dialog) {
                this.showDialog()
            }
        },
    },
      computed: {
          // ── Config-driven computed properties ──
          loginConfigLoaded() {
              return this.$store.getters.loginConfigLoaded
          },
          configTheme() {
              return (this.loginConfig && this.loginConfig.theme) || {}
          },
          configBranding() {
              return (this.loginConfig && this.loginConfig.branding) || {}
          },
          configFeatures() {
              return (this.loginConfig && this.loginConfig.features) || {}
          },
          configFooter() {
              return (this.loginConfig && this.loginConfig.footer) || {}
          },
          configLogo() {
              return this.configBranding.logo || null
          },
          configTitle() {
              return this.configBranding.title || ''
          },
          configSubtitle() {
              return this.configBranding.subtitle || ''
          },
          useCustomBackground() {
              // Use custom background when video is disabled or a background image/color is set
              return this.configFeatures.showVideo === false ||
                     !!this.configTheme.backgroundImage ||
                     !!this.configTheme.backgroundColor
          },
          customBgStyle() {
              const style = {
                  width: '100%',
                  minHeight: '100vh',
                  height: '100%',
                  position: 'relative',
                  overflow: 'hidden',
              }
              if (this.configTheme.backgroundColor) {
                  style.backgroundColor = this.configTheme.backgroundColor
              }
              if (this.configTheme.backgroundImage) {
                  style.backgroundImage = "url('" + this.configTheme.backgroundImage + "')"
                  style.backgroundSize = 'cover'
                  style.backgroundPosition = 'center'
                  style.backgroundRepeat = 'no-repeat'
              }
              if (this.configTheme.fontFamily) {
                  style.fontFamily = this.configTheme.fontFamily
              }
              return style
          },
          hasOverlay() {
              return !!this.configTheme.backgroundOverlayColor
          },
          overlayStyle() {
              return {
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: this.configTheme.backgroundOverlayColor,
                  zIndex: 0,
              }
          },
          cardStyle() {
              const style = { minWidth: this.configTheme.maxCardWidth || '400px' }
              if (this.twoFactorAuth && this.qrCode) {
                  // QR code mode: full opacity
              } else {
                  style.opacity = this.configTheme.cardOpacity || '80%'
              }
              if (this.configTheme.cardBackgroundColor) {
                  style.backgroundColor = this.configTheme.cardBackgroundColor
              }
              if (this.configTheme.cardBorderRadius) {
                  style.borderRadius = this.configTheme.cardBorderRadius
              }
              return style
          },
          cardTitleClass() {
              // Keep original classes, allow override via primaryColor
              return this.configTheme.primaryColor ? 'subheading' : 'accent white--text subheading'
          },
          cardTitleStyle() {
              if (this.configTheme.primaryColor) {
                  return {
                      backgroundColor: this.configTheme.primaryColor,
                      color: this.configTheme.primaryTextColor || '#ffffff',
                  }
              }
              return {}
          },
          loginBtnStyle() {
              if (this.configTheme.primaryColor) {
                  return {
                      backgroundColor: this.configTheme.primaryColor + ' !important',
                      color: this.configTheme.primaryTextColor || '#ffffff',
                  }
              }
              return {}
          },
          showPoweredBy() {
              // Default: show if brandName !== 'Carnot Innovations'
              // Config can explicitly hide it
              if (this.configFeatures.showPoweredBy === false) return false
              return this.brandName !== 'Carnot Innovations'
          },
          footerText() {
              return this.configFooter.text || ''
          },
          footerLinks() {
              return this.configFooter.links || []
          },
          // ── Original computed properties ──
          mobileMode() {
              return process.env.VUE_APP_MOBILE_MODE ? true : false
          },
          authMode(){
              if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
                  return "msal"
              } else {
                  return "main"
              }
          },
          brandName(){
              if (localStorage.getItem('brandingOverride')== '1'){
                  return "Carnot Innovations"
              }
              return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
          },
      },
    async mounted () {
        // Wait for login config to load before showing dialog to avoid FOUC
        if (this.loginConfigLoaded) {
            this.showDialog()
        }
        // else: watcher above will trigger showDialog once loaded
    },
    methods: {
      async showDialog() {
        let me = this;
        this.dialog = true
        if (process.env.VUE_APP_EXTERNAL_AUTH && process.env.VUE_APP_EXTERNAL_AUTH === "msal") {
          me.loading = true
          await this.sleep(1200)
          if (me.$msal.isAuthenticated()) {
            await this.sleep(600)
            let token = await me.$msal.acquireToken()
            await this.sleep(500)
            if (!token || !token.accessToken) {
                if (typeof(msal)!= "undefined"){
                    msal.clearCache()
                    await this.sleep(100)
                    window.location.reload()
                }
                me.authOverride = true
            } else if (me.$route.query.wantedRoute) {
              window.location.href = me.$route.query.wantedRoute
            }
            me.loading = false
          } else {
            me.loading=false
          }
        } else if (this.$route.query.loginopts){
            this.showAdvancedLoginOptions = true
        }
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
        redirectHome() {
            this.$router.push({
                name: "home",
            });
        },
      async loginProcess () {
        this.message = 'Login in Progress.'
          let longExp=this.showAdvancedLoginOptions&&this.longExpToken
          let res = await login(this.username, this.password, this.twoFactorInput,longExp)
          if (res.result==='OK') {
            this.$store.dispatch('setUser', {token: res.token, content: jwtDecode(res.token)})
            localStorage.setItem('pass', res.token)
              if(this.$route.query.wantedRoute){
                  window.location.href=this.$route.query.wantedRoute;
              } else {
                  window.location.href="/";
              }

          } else if (res.result==='2fa') {
            this.message = res.desc
            this.twoFactorAuth = true
            if (res.url){
                this.qrCode = res.url
            }
          }else{
            this.message = res.desc ? res.desc : 'Login Failed.  Please try again.'
          }
      }
    }
  }
</script>

<style scoped>
.login-custom-bg {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    position: relative;
    overflow: hidden;
}
.login-bg-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 0;
}
.login-footer-text {
    font-size: 12px;
    text-align: center;
    padding-bottom: 16px;
}
</style>
